import { IconProps } from "@/types/icons";

export const Pause = ({
  width = 35,
  height = 34,
  className,
  decorative = false,
  ariaLabel = "Pausa",
  ...props
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 35 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden={decorative}
    aria-label={!decorative ? ariaLabel : undefined}
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M29.6874 4.97921C26.4766 1.76827 22.2075 0 17.6666 0C13.1258 0 8.85664 1.76827 5.64583 4.97921C2.43496 8.19008 0.666626 12.4591 0.666626 17C0.666626 21.5409 2.43489 25.81 5.64583 29.0208C8.85671 32.2317 13.1258 34 17.6666 34C22.2075 34 26.4766 32.2317 29.6874 29.0208C32.8983 25.8099 34.6666 21.5409 34.6666 17C34.6666 12.4591 32.8984 8.19002 29.6874 4.97921ZM17.6666 31.9184C9.44062 31.9184 2.74826 25.226 2.74826 17C2.74826 8.77399 9.44062 2.08164 17.6666 2.08164C25.8926 2.08164 32.585 8.77399 32.585 17C32.585 25.226 25.8926 31.9184 17.6666 31.9184Z"
        fill="white"
      />
      <path
        d="M10.381 9.02039V24.9796H16.6259V9.02039H10.381ZM14.5443 22.8979H12.4626V11.102H14.5443V22.8979Z"
        fill="white"
      />
      <path
        d="M19.0833 9.02039V24.9796H25.3282V9.02039H19.0833ZM23.2465 22.8979H21.1649V11.102H23.2465V22.8979Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="34"
          height="34"
          fill="white"
          transform="translate(0.666626)"
        />
      </clipPath>
    </defs>
  </svg>
);
